import styles from './ErrorView.module.scss'
import { ErrorViewProps } from './ErrorView.types'
import { Card, Flex, Typography } from '@percent/lemonade'

export function ErrorView({ errorMessage, errorMessageSize = 'large' }: ErrorViewProps) {
  return (
    <Flex direction="column" align="center" justify="center" data-testid="error-view" className={styles.errorContainer}>
      <Flex>
        <Card>
          <Typography variant={errorMessageSize} className={styles.errorMessage}>
            {errorMessage}
          </Typography>
        </Card>
      </Flex>
    </Flex>
  )
}
